import type { CvContent } from './types'

export const fr: CvContent = {
  tagline: 'Performeuse · Danseuse · Chanteuse · Professeure de danse',
  intro:
    'Étudiante en BA Danse / BA Pédagogie de la danse au Lucia Marthas Institute for Performing Arts. Expérience de scène notamment au Ziggo Dome, à Ahoy et à AFAS Live, et dance captain du spectacle annuel du LMIPA.',
  about:
    "Je suis une performeuse enthousiaste et flexible, dotée d'un grand sens des responsabilités. Persévérante, je suis fiable et toujours ponctuelle. Je travaille de manière organisée, je garde mes tâches bien en ordre et je suis une joueuse d'équipe capable de s'adapter rapidement. Parallèlement à mon travail sur scène, j'aime beaucoup enseigner et transmettre ma passion pour la comédie musicale et les arts de la scène. Avec mon énergie positive et mon engagement, je contribue à une production fluide et réussie.",
  features: [
    { label: 'Couleur des cheveux', value: 'Blond' },
    { label: 'Yeux', value: 'Bleus' },
    { label: 'Taille', value: '1,70 m' },
    { label: 'Date de naissance', value: '27/03/2005' },
  ],
  skills: [
    {
      heading: 'Chant',
      lines: ['Type de voix : soprano', 'Tessiture : E3 à C6', 'Formation en :'],
      items: ['Jazz', 'Comédie musicale', 'Pop', 'Classique', 'Ensemble et polyphonie'],
    },
    {
      heading: 'Danse',
      lines: ['Formation en :'],
      items: [
        'Ballet',
        'Jazz',
        'Horton',
        'Moderne',
        'Différents styles latins et portés',
        'Théâtre musical',
        'Commercial',
        'Claquettes',
      ],
    },
    {
      heading: 'Jeu d’acteur',
      lines: [],
      items: [
        'Improvisation',
        'Scènes de groupe',
        'Monologues',
        'Duologues',
        'Jeu au théâtre et face caméra',
      ],
    },
  ],
  experience: [
    {
      title: 'Spectacle annuel LMIPA',
      period: 'Juil. 2014 – aujourd’hui',
      description:
        "Lors du spectacle annuel, j'ai été dance captain et responsable de plusieurs pièces. J'ai également créé des chorégraphies pour les sections plus jeunes, en mettant à profit ma créativité et mon expérience de professeure de danse.",
    },
    { title: 'Christmas Show, Ziggo Dome', period: 'Déc. 2016' },
    { title: 'Kinderen voor Kinderen 40 ans, Ahoy', period: '2018' },
    { title: 'Lang Leve de Muziek Show AVROTROS', period: '2018 – 2019' },
    { title: 'Katja en Babbette Discobal, AFAS Live', period: 'Nov. 2025' },
    {
      title: 'Workshops',
      period: '2023 – aujourd’hui',
      bullets: [
        'Ateliers/cours avec Malou Linders, Denden Karadeniz, Sergio Reis, Jordy Sparidaens, Anneke Ghysens et Laurent Flamment',
        'Ateliers/cours avec Caroline Dijkhuizen, Andy Señor JR, Mary-Ann Lamb, Valerie Pettifort et Michiel Varga',
      ],
    },
    {
      title: 'Professeure de danse, Lucia Marthas Institute for Performing Arts',
      period: 'Sept. 2023 – aujourd’hui',
    },
  ],
  education: [
    {
      period: '2023',
      school: 'Gerrit van der Veen College',
      detail: 'VWO / classe DAMU LMIPA',
    },
    {
      period: 'Sept. 2023 – juil. 2027',
      school: 'Lucia Marthas Institute for Performing Arts',
      detail: 'BA Danse / BA Pédagogie de la danse',
    },
  ],
}
